define('view/settings/disclosureResolutionSetting.page.view',['require','exports','module','blockit','uikit/uikit','marionette','templates','fukit'],function(require, exports, module) {
  // prettier-ignore
  var BlocKit                                       = require('blockit'),
      UIKit                                         = require('uikit/uikit'),
      Mn                                            = require('marionette'),
      Templates                                     = require('templates'),
      ShowModalOnNavigateWithUnsavedChangesBehavior = require('fukit').ShowModalOnNavigateWithUnsavedChangesBehavior;
;

  var DisclosureResolutionSettingPageView = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      modals: {},
      root: {
        type: BlocKit.FullWidthLayoutView,
        pageHeader: {
          headerText: 'Disclosure Resolution Setting',
          actions: [],
          className: 'simplyTransparent'
        },
        contentColumn: {
          components: [
            {
              type: BlocKit.AttachedComponentsContainerView,
              components: [
                {
                  type: Mn.ItemView.extend(UIKit.ComponentMixin),
                  template: Templates.App['disclosure.review.setting'],
                  attributes: {
                    id: 'disclosureResolutionPanel'
                  },
                  headingText: 'Disclosure Resolution',
                  settingDescription: 'This setting allows COI Administrators to control which users are allowed to resolve disclosures according to roles assigned in Admin. By default, users with the COI Administrator role can resolve any disclosure, while users with the COI Primary Reviewer or COI Reviewer role(s) can resolve only disclosures assigned to them for review. By updating this setting, only COI Administrators at your organization will be allowed to resolve disclosures. COI Primary Reviewers and COI Reviewers will no longer be able to resolve disclosures.',
                  settingLabel: 'Who can resolve disclosures?',

                  internalViewOptions: {
                    choiceAdminOnly: {
                      text: 'Only those with the COI Administrator role',
                      attributes: { id: "choiceAdminOnly" },
                      className: UIKit.Checkbox.prototype.className + ' resolution-radio',
                      checkboxId: 'choiceAdminOnly',
                      radio: true,
                      useLabel: true,
                      model: '@resources.settingsModel',
                      bindings: {
                        value: 'isAdminOnly'
                      },
                      onBeforeRender: function() {
                        const model = this.model;

                        this.on('change:value', function(view, newValue, oldValue) {
                          model.set({resolveAdminOnly: newValue });
                        });
                      }
                    },
                    choiceAdminorReviewers: {
                      text: 'Those with COI Primary Reviewer, COI Reviewer, and/or COI Administrator role(s)',
                      attributes: { id: "choiceAdminorReviewers" },
                      className: UIKit.Checkbox.prototype.className + ' resolution-radio',
                      checkboxId: 'choiceAdminOnly',
                      radio: true,
                      useLabel: true,
                      model: '@resources.settingsModel',
                      bindings: {
                        value: 'isAdminOrReviewer'
                      },
                      onBeforeRender: function() {
                        const model = this.model;

                        this.on('change:value', function(view, newValue, oldValue) {
                          // NOTE: this value is always the boolean opposite of the other checkbox,
                          // so set it the opposite of newValue
                          model.set({resolveAdminOnly: !newValue });
                        });
                      }
                    },
                  }
                },
              ]
            },
            {
              type: UIKit.Button,
              text: 'Save',
              icon: 'save',
              color: 'primary',
              model: '@resources.settingsModel',
              onPress: function() {
                this.model.save();
              },
              behaviors: {
                EnableOnlyOnUnsavedChangesBehavior: {
                  model: '@resources.settingsModel',
                  behaviorClass: BlocKit.EnableOnlyOnUnsavedChangesBehavior,
                },
                ShowModalOnNavigateWithUnsavedChangesBehavior: {
                  behaviorClass: ShowModalOnNavigateWithUnsavedChangesBehavior,
                },
              }
            }
          ],
        }, //end of contentColumn
      },
    },
  });

  module.exports = DisclosureResolutionSettingPageView;
});

